"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _CompositionNotFound = _interopRequireDefault(require("composer-lib/components/composer/CompositionNotFound"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("composer-lib/lib/utils");

var _constants = require("composer-lib/lib/constants");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftExtend = require("draft-extend");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _editorChangeHelpers = require("composer-lib/lib/helpers/editorChangeHelpers");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var Composer = (0, _createReactClass.default)({
  displayName: "Composer",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func.isRequired,
    auth: _propTypes.default.object.isRequired,
    backLink: _propTypes.default.string,
    children: _propTypes.default.node.isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    handleKeyCommand: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    removeKeyCommandListener: _propTypes.default.func.isRequired,
    saveChangedComposition: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired
  },
  renderContent: function renderContent() {
    var _this$props = this.props,
        addKeyCommandListener = _this$props.addKeyCommandListener,
        composition = _this$props.composition,
        handleKeyCommand = _this$props.handleKeyCommand,
        removeKeyCommandListener = _this$props.removeKeyCommandListener,
        saveChangedComposition = _this$props.saveChangedComposition,
        saveState = _this$props.saveState;

    if ((0, _editorChangeHelpers.shouldRenderEmptyState)({
      saveState: saveState,
      composition: composition
    })) {
      return _react.default.createElement("div", {
        className: "body-editor-empty-state text-center m-top-5"
      }, _react.default.createElement("p", {
        className: "body-editor-empty-state-header m-bottom-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "composer-lib.composer.bodyEmptyStateHeader"
      })), _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "composer-lib.composer.bodyEmptyStateBody"
      })));
    } // Give all component (not element) children the key command handler prop


    return _react.default.Children.map(this.props.children, function (child) {
      if (child && (0, _utils.isReactComponent)(child)) {
        return _react.default.cloneElement(child, {
          addKeyCommandListener: addKeyCommandListener,
          handleKeyCommand: handleKeyCommand,
          removeKeyCommandListener: removeKeyCommandListener,
          saveChangedComposition: saveChangedComposition
        });
      }

      return child;
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        backLink = _this$props2.backLink,
        composition = _this$props2.composition,
        lock = _this$props2.lock,
        saveState = _this$props2.saveState;
    var content = saveState.content,
        title = saveState.title;

    if (composition.status === _constants.RequestStatus.PENDING) {
      return _react.default.createElement(_UIFlex.default, {
        justify: "center",
        align: "center"
      }, _react.default.createElement(_UILoadingSpinner.default, {
        className: "loading-spinner-page",
        size: "medium",
        use: "success"
      }));
    }

    if (!content || title === null) {
      return _react.default.createElement(_CompositionNotFound.default, {
        backLink: backLink
      });
    }

    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    var classes = (0, _classnames.default)('composer-container', {
      'comment-mode': locked,
      'no-edit': locked || composition.isReadOnly(),
      updated: composition.getIn(['data', 'justUpdated'])
    });
    return _react.default.createElement("div", {
      className: classes
    }, this.renderContent());
  }
});

var _default = (0, _draftExtend.KeyCommandController)(Composer);

exports.default = _default;
module.exports = exports.default;